import React from 'react';
import { TomosAccordion } from '../ui/TomosAccordion';
import { BonosAccordion } from '../ui/BonosAccordion';
export function Includes() {
  return <section className="py-24 bg-black" data-id="element-49">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-50">
        <div className="text-center mb-16" data-id="element-51">
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-52">
            ¿Qué trae este pack?
          </h2>
          <p className="text-lg text-white/70 max-w-2xl mx-auto" data-id="element-53">
            Todo lo que necesitas para cruzar la meta, organizado en un solo
            lugar.
          </p>
        </div>

        <TomosAccordion data-id="element-54" />

        <div className="text-center mb-12" data-id="element-55">
          <span className="inline-block px-3 py-1 bg-brand-green/15 text-brand-green text-xs font-bold tracking-wider uppercase rounded-full mb-4" data-id="element-56">
            Bonos exclusivos
          </span>
          <h3 className="font-serif text-3xl md:text-4xl font-bold text-white mb-3" data-id="element-57">
            Llevando HOY tenés estos bonos GRATIS
          </h3>
          <p className="text-white/70 max-w-2xl mx-auto" data-id="element-58">
            Herramientas prácticas y guías validadas para aplicar desde el día
            uno.
          </p>
        </div>

        <BonosAccordion data-id="element-59" />
      </div>
    </section>;
}